<template>
  <el-form-item class="upload-css" :class="!uploadShow ? 'new-upload' : ''" :label="label" :prop="field" :ref="field">
    <el-upload action :http-request="upLoad" :accept="accept" :before-upload="beforeUp" :file-list="data[field]"
      :on-remove="handleRemove" :on-preview="handlePreview" :on-exceed="exceed" multiple :limit="limit">
      <el-button size="small" :type="type" v-if="uploadShow">{{ name }}</el-button>
    </el-upload>
  </el-form-item>
</template>
<script>
import XEUtils from 'xe-utils'
export default {
  data() {
    return {
      formData: null
    }
  },
  props: {
    field: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '上传文件'
    },
    name: {
      type: String,
      default: '点击上传',
    },
    data: {
      type: Object,
      required: true,
    },
    accept: {
      type: String,
      default: '',
    },
    rules: {
      type: Object,
      required: true
    },
    limit: {
      type: Number,
      default: 10
    },
    required: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: '请上传文件'
    },
    uploadType: {
      type: Array,
      default: () => {
        return []
      }
    },
    uploadTypeText: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary'
    },
    uploadShow: {
      type: Boolean,
      default: true
    },
    model: {
      type: String,
      default: ''
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!XEUtils.isArray(this.data[this.field])) {
        this.$set(this.data, this.field, [])
      }
      this.getRules()
    },
    getRules() {
      if (this.required) {
        this.$set(this.rules, this.field, [{
          required: this.required,
          message: this.message,
          trigger: 'change'
        }])
      }
    },
    /** 限制上传 */
    beforeUp(file) {
      let suffix = this.getFileType(file.name)
      let suffixArray = [], text
      suffixArray = this.uploadType
      text = this.uploadTypeText
      if (suffixArray.indexOf(suffix) === -1 && suffixArray.length !== 0) {
        this.$message({
          message: text,
          type: 'error',
          duration: 2000
        })
        return false
      } else {
        this.formData = new FormData()
        this.formData.append('contractFile', file)
        this.formData.append("modelCode", this.model)
        this.formData.append("fieldCode", this.field)
      }
    },
    getFileType(name) {
      let startIndex = name.lastIndexOf('.')
      if (startIndex !== -1) {
        return name.slice(startIndex + 1).toLowerCase()
      } else {
        return ''
      }
    },
    /** 上传 */
    upLoad(file) {
      const size = Number((file.file.size / 1024 / 1024).toFixed(2))
      const type = this.getFileType(file.file.name)
      this.$axios.post('/account/oss/ossFile', this.formData).then((res) => {
        if (res) {
          this.data[this.field].push({
            name: file.file.name,
            url: res.data.data.url,
            type: type,
            size: size
          })
          this.$refs[this.field].clearValidate()
        } else {
          this.$message.warning('上传失败')
        }
      })
    },
    /** 超出个数限制 */
    exceed() {
      this.$message.warning(`只允许上传${this.limit}个文件`)
    },
    /** 点击下载文件 */
    handlePreview(file) {
      this.$confirm('确定查看或下载该文件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const fileUrl = file.url.split('@@')
        const a = document.createElement('a')
        a.href = fileUrl[0]
        a.target = '_blank'
        a.download = file.name
        a.click()
      }).catch(() => {
      })
    },
    /** 删除文件 */
    handleRemove(file) {
      try {
        this.data[this.field].forEach((item, index) => {
          if (file.url === item.url) {
            this.data[this.field].splice(index, 1)
            throw new Error("ending")
          }
        })
      } catch (e) {
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.upload-css {
  :deep(.gp-upload-list__item.is-ready) {
    display: none;
  }

  :deep(.gp-upload-list__item) {
    transition: none !important;
  }

  :deep(.gp-upload-list__item .gp-icon-close-tip) {
    display: none !important;
  }
}

.new-upload {
  :deep(.gp-upload) {
    display: none !important;
  }

  :deep(.gp-icon-close) {
    display: none !important;
  }
}
</style>
